import { GDFCcfpRecord } from '../../../gdf/type';

const tops = ['', '> 40,000 ft MSL', '35,000 - 39,000 ft MSL', '30,000 - 34,000 ft MSL', '25,000 - 29,000 ft MSL'];
const growth = ['', 'Fast Positive', 'Positive', 'No change', 'Negative'];
const confidence = ['', 'High (50-100%)', '', 'Low (25-49%)'];
const coverage = ['', 'High/solid (75-100%)', 'Medium (40-74%)', 'Low/sparse (25-39%)'];

export default function TcfTooltip(props: { record: GDFCcfpRecord; small?: boolean }) {
    const item = props.record;
    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'max-content max-content', columnGap: '2.5rem' }}>
            <div>Tops:</div>
            <div>{tops[item.tops]}</div>
            {!props.small && (
                <>
                    <div>Growth:</div>
                    <div>{growth[item.growth]}</div>
                </>
            )}
            <div>Confidence:</div>
            <div>{confidence[item.prob]}</div>
            <div>Coverage:</div>
            <div>{coverage[item.coverage]}</div>
            {!props.small && (
                <>
                    <div>Speed:</div>
                    <div>{item.speed} knots</div>
                    <div>Direction:</div>
                    <div>{item.direction} degrees</div>
                </>
            )}
        </div>
    );
}
